export const tranformErrorResponses = (error) => {
  let errorResponse = {};
  switch(error?.response?.status) {
    case 400: {
      errorResponse = {
        title: 'เกิดข้อผิดพลาด',
        message: error.response?.data?.data?.message ?? error.response?.data?.message,
        buttons: error.response?.data?.data?.buttons,
      };
      break;
    };
    case 403: {
      errorResponse = {
        title: 'เกิดข้อผิดพลาด',
        message: error.response?.data?.message
      };
      break;
    }
    case 500: {
      errorResponse = {
        title: 'เกิดข้อผิดพลาด',
        message: error.response?.statusText
      };
      break;
    }
    default: {
      errorResponse = error;
      break;
    }
  }
  return errorResponse;
};

export const errorMessageResponse = (error) => error?.response?.data?.message || `An error occurred (${error?.response?.status})`